/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { connect } from 'react-redux';

import scrollTo from 'shared/modules/page/actions/scrollTo';
import TvGuide from '../components/TvGuide';
import { saveScrollPosition } from '../actions';
import {
  getScrollPosition,
  getFilteredChannelsByZapNumber
} from '../selectors';
import getPageData from 'shared/modules/page/selectors/getPageData';
import { hasPageUnifiedMenu } from 'shared/modules/page/selectors/hasPageMenuUnified';
import {
  HEADER_DESKTOP_HEIGHT,
  HEADER_MOBILE_HEIGHT,
  HEADER_UNIFIED_DESKTOP_HEIGHT,
  HEADER_UNIFIED_MOBILE_HEIGHT
} from 'shared/constants/heights';

const mapStateToProps = (state, { keptChannels }) => {
  const pageData = getPageData(state);
  const hasUnifiedMenu = hasPageUnifiedMenu(pageData);

  const viewportOffsetTop = {
    desktop: hasUnifiedMenu
      ? HEADER_UNIFIED_DESKTOP_HEIGHT
      : HEADER_DESKTOP_HEIGHT,
    tablet: hasUnifiedMenu && HEADER_UNIFIED_DESKTOP_HEIGHT,
    phablet: hasUnifiedMenu && HEADER_UNIFIED_MOBILE_HEIGHT,
    phone: hasUnifiedMenu && HEADER_UNIFIED_MOBILE_HEIGHT,
    hd: hasUnifiedMenu ? HEADER_UNIFIED_DESKTOP_HEIGHT : HEADER_MOBILE_HEIGHT
  };

  return {
    channels: getFilteredChannelsByZapNumber(state, { keptChannels }),
    scrollPosition: getScrollPosition(state),
    viewportOffsetTop
  };
};

const mapDispatchToProps = {
  saveScrollPosition,
  scrollTo
};

export default connect(mapStateToProps, mapDispatchToProps)(TvGuide);
